import ApiWebCallEvo, {
   API_URL_ORDER_DETAIL_PART
} from "./calls/evo-api-call";

export default class OrderDetailDataProvider  {

    constructor() {}

    /**
     * @param orderHash
     * @param params
     * @param headers
     */
    public async getData(orderHash : string, params = {}, headers = {}) {

        let apiCall = new ApiWebCallEvo(
            API_URL_ORDER_DETAIL_PART + '/' + orderHash + '/detail',
            params,
            headers
        );

        let res = await apiCall.makeCall();

        return res;
    }
}